/**
 * 查询列表
 */
 import Layout from '../../pages/layout/Frame';

 const userFeed = {
     path: "/userFeed",
     component: Layout,
     meta: {title: '用户反馈'},
     name: "UserFeedBack",
     children: [
         {
             path: "/userFeed/UserFeedBack",
             component: () => import('../../pages/userFeed/UserFeedBack'),
             meta: {title: '用户反馈',},
             name: 'UserFeedBack',
         },
     ]
 };
 
 export default userFeed
 